export function roundToFirstDecimalPlace(value: number): number {
  return Math.round(value * 10) / 10
}
